var swiperBanner = new Swiper('.blog-slider', {
      effect: 'fade',
      loop: true,
 	  autoplay: {
       delay: 3000,
      },
      autoHeight: true,
      pagination: {
        el: '.blog-slider__pagination',
        clickable: true,
      },
  	  navigation: {
        nextEl: '.banner-controls .swiper-button-next',
        prevEl: '.banner-controls .swiper-button-prev',
      }
 });
 let btnPlayBanner = document.querySelectorAll('.btn-play-banner');
  btnPlayBanner.forEach((bt)=>{
      bt.addEventListener('click', function (e) {	
        var par = this.closest('.blog-slider__item');
        var wrapVideo = par.querySelector('.banner-video');
        var btnStopBanner = par.querySelector('.btn-stop-banner');    
        var bw = par.querySelector('.back-wrap'); 
        var sl = this.closest('.blog-slider');
        var wrapControls = sl.querySelector('.banner-controls');      
        wrapVideo.play();
        this.style.display = (this.style.display == 'none') ? 'flex' : 'none';
        btnStopBanner.style.display = 'flex';
        bw.classList.add("play");
        par.classList.add("play");
        wrapControls.classList.add("play");
        swiperBanner.autoplay.stop();
        
      });
  });

let btnStopBanner = document.querySelectorAll('.btn-stop-banner');
  btnStopBanner.forEach((bt)=>{
      bt.addEventListener('click', function (e) {	
        var par = this.closest('.blog-slider__item');
        var wrapVideo = par.querySelector('.banner-video');
        var btnPlayBanner = par.querySelector('.btn-play-banner');    
        var bw = par.querySelector('.back-wrap'); 
        var sl = this.closest('.blog-slider');
        var wrapControls = sl.querySelector('.banner-controls');      
        wrapVideo.pause();
        this.style.display = (this.style.display == 'none') ? 'flex' : 'none';
        btnPlayBanner.style.display = 'flex';
        bw.classList.remove("play");
        par.classList.remove("play");
         wrapControls.classList.remove("play");
        swiperBanner.autoplay.start();
      });
  })


function animateMarquee(el, duration) {

  const innerEl = el.querySelector('.marquee__inner');
  const innerWidth = innerEl.offsetWidth;
  const cloneEl = innerEl.cloneNode(true);
    const cloneEl2 = innerEl.cloneNode(true);
      const cloneEl3 = innerEl.cloneNode(true);
  
  el.appendChild(cloneEl);
  el.appendChild(cloneEl2);
   el.appendChild(cloneEl3);
  
  let start = performance.now();
  let progress;
  let translateX;

  requestAnimationFrame(function step(now) {
    progress = (now - start) / duration;
 
    if (progress > 1) {
    	progress %= 1;
      start = now;
    }

    translateX = innerWidth * progress;
    
    innerEl.style.transform = `translate3d(-${translateX}px, 0 , 0)`;
    cloneEl.style.transform = `translate3d(-${translateX}px, 0 , 0)`;
     cloneEl2.style.transform = `translate3d(-${translateX}px, 0 , 0)`;
        cloneEl3.style.transform = `translate3d(-${translateX}px, 0 , 0)`;
    requestAnimationFrame(step);
  });

};

const marquee1 = document.querySelector('#marquee1');
  if ( marquee1 !== null){
		animateMarquee(marquee1, 10000);
  }